<template>
    <div>

        <!-- List header -->
        <a-row type="flex" :gutter="24">
            <a-col :span="12" class="mb-24">
				<a-dropdown :trigger="['click']">
                    <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
						Category <a-icon class="ml-5" type="down" />
					</a-button>
                    <a-menu slot="overlay" v-model="chosenCategory">
                        <template v-for="c in categories">
                            <a-menu-item :key="c.categoryId"> 
                                {{ c.categoryName }}
                            </a-menu-item>
                        </template>
                    </a-menu>
                </a-dropdown>
			</a-col>

            <a-col :span="12" class="mb-24 text-right">
                <a-button @click="openProductAddModal" class="ml-15">
					<i class="ni ni-archive-2 mr-5"></i> ADD PRODUCT
				</a-button>
            </a-col>
        </a-row>
        <!-- / List header -->

        <!-- List card -->
        <a-card :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">
            <products-list-view />
        </a-card>
        <!-- / List card -->
        <product-add-view-modal ref="productAddModal"/>
        
    </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import ProductsListView from './ProductsListView.vue'
import ProductAddViewModal from './ProductAddViewModal.vue'


export default {

    components : {
        ProductsListView,
        ProductAddViewModal
        
    },

    computed : {
        ...mapState({
            categories : state => state.products.categoriesFromProductsList
        }),
        ...mapGetters({
            
        })
    },
    data () {
        return {
            chosenCategory : null
        }
    },

    methods : {
        openProductAddModal() {
            this.$refs['productAddModal'].showModal();
        },
        openSubProductUpdateModal() {

        },
        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },
    },

    async created () {
        this.$message.loading('Loading data...', 0);
        await this.sleep(2000);
        await this.$store.dispatch('products/getProductsAction', { });
        await this.$store.dispatch('categories/getCategoriesAction', { });
        await this.$store.dispatch('products/getTaxesAction', { });
        this.$message.destroy();
    } 
}
</script>